import { TechAchatFNS } from './TechAchatFNS';
import { TypeOuiNonNbCandidatReduitFNSSimple } from './TypeOuiNonNbCandidatReduitFNSSimple';
import { PresOffresFNS } from './PresOffresFNS';
import { TypeOuiNon } from './TypeOuiNon';
export class TypeProcFNS {
	public capaciteExercice: string;

	public capaciteEcoFin: string;

	public capaciteTech: string;

	public procedureAdapteeO: string;

	public procedureAdapteeR: string;

	public dateReceptionOffres: string;

	public nbCandidatReduit: TypeOuiNonNbCandidatReduitFNSSimple;

	public variantes: TypeOuiNon;

	public criteresAttrib: string;

	public presOffres: PresOffresFNS;

	public attributionSansNegociation: TypeOuiNon;

	public categorieAcheteur: string;

	public techAchat: TechAchatFNS;

	constructor() {
		this.capaciteExercice = '';
		this.capaciteEcoFin = '';
		this.capaciteTech = '';
		this.procedureAdapteeO = '';
		this.procedureAdapteeR = '';
		this.dateReceptionOffres = '';
		this.nbCandidatReduit = new TypeOuiNonNbCandidatReduitFNSSimple();
		this.variantes = new TypeOuiNon();
		this.criteresAttrib = '';
		this.presOffres = new PresOffresFNS();
		this.attributionSansNegociation = new TypeOuiNon();
		this.categorieAcheteur = '';
		this.techAchat = new TechAchatFNS();
	}
}
